import { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import { Text } from "@kanda-libs/ks-design-library";
import useJobCustomerDetailsProps from "components/job/JobLayout/JobCustomerDetails/useJobCustomerDetailsProps";
import { selectors } from "store";

export interface JobCustomerDetailsProps {}

const JobCustomerDetails: FunctionComponent<JobCustomerDetailsProps> =
  function () {
    const isLoading = useSelector(selectors.getIsLoading);
    const { name, email, phone, address } = useJobCustomerDetailsProps();

    return (
      <div className="flex flex-col px-5 py-4 mb-2 border rounded-lg border-neutral-300 last:mb-0 shadow-card">
        <Text text="To:" className="mb-2 text-20-24-em" />
        <div className="flex flex-row">
          <div className="flex min-w-32">
            <Text
              text="Name:"
              className="mr-2 text-14-22-em"
              isLoading={isLoading}
            />
          </div>
          <Text text={name} className="text-14-22" isLoading={isLoading} />
        </div>
        <div className="flex flex-row">
          <div className="flex min-w-32">
            <Text text="Email:" className="mr-2 text-14-22-em" />
          </div>
          <Text text={email} className="text-14-22" isLoading={isLoading} />
        </div>
        <div className="flex flex-row">
          <div className="flex min-w-32">
            <Text
              text="Phone:"
              className="mr-2 text-14-22-em"
              isLoading={isLoading}
            />
          </div>
          <Text text={phone} className="text-14-22" isLoading={isLoading} />
        </div>
        <div className="flex flex-row">
          <div className="flex min-w-32">
            <Text
              text="Address:"
              className="mr-2 text-14-22-em"
              isLoading={isLoading}
            />
          </div>
          <Text text={address} className="text-14-22" isLoading={isLoading} />
        </div>
      </div>
    );
  };

export default JobCustomerDetails;
